import { useEffect, useState } from "react";

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [userId, setUserId] = useState<number | null>(null);
  const [userRole, setUserRole] = useState<number>(0);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);

      setIsAuthenticated(true);
      setUserId(parsedUser.userId);
      setUserRole(parsedUser.role);
    }
  }, [userId, userRole]);

  const logoutUser = () => {
    setIsAuthenticated(false);
    setUserId(null);
    setUserRole(0);
  };

  return {
    isAuthenticated,
    userId,
    userRole,
    logoutUser,
    setIsAuthenticated,
  };
};
